/**
 * Outils de l'assistant de création d'une prise en charge (écran étape par étape).
 * Gardés ici, sans import d'écran, pour pouvoir être testés seuls.
 */

/** Accessoires proposés en un clic ; le reste se tape à la main. */
export const ACCESSOIRES = ["Chargeur", "Câble", "Manette", "Joy-Con", "Boîte", "Pochette", "Carte mémoire", "Stylet"];

/** Clé où l'outil de calibration (dualshock-tools, même origine) note la dernière manette branchée. */
export const CLE_DERNIERE_MANETTE = "lastConnectedController";

/** Texte enregistré dans « accessoires » : les cases cochées puis le texte libre. */
export function texteAccessoires(coches = [], autre = "") {
    const morceaux = [...coches];
    const libre = (autre || "").trim();
    if (libre) {
        morceaux.push(libre);
    }
    return morceaux.length ? morceaux.join(", ") : "Aucun";
}

/** Une manette PlayStation, dont l'outil de calibration sait lire le numéro de série ? */
export function estManettePlayStation(appareil) {
    const texte = ((appareil?.marque?.nom || "") + " " + (appareil?.nom || "")).toLowerCase();
    return /dualshock|dualsense|ds4|ds5|manette ps|manette playstation|(sony.*manette)|(manette.*sony)/.test(texte);
}

/**
 * Numéro de série de la manette branchée dans l'outil de calibration après `depuis` (horodatage en ms),
 * ou null. DualShock 4 : adresse Bluetooth ; DualSense : numéro de série de la carte.
 */
export function numeroManetteDepuis(stockage, depuis) {
    let info = null;
    try {
        info = JSON.parse(stockage.getItem(CLE_DERNIERE_MANETTE) || "null");
    } catch (e) {
        return null;
    }
    if (!info || !info.serialNumber || !info.timestamp) {
        return null;
    }
    if (new Date(info.timestamp).getTime() < depuis) {
        return null;
    }
    return {
        serial: String(info.serialNumber).trim(),
        modele: [info.deviceName, info.boardModel, info.color].filter(Boolean).join(" · "),
    };
}

/** Nom affiché d'un appareil de l'annuaire. */
export function nomAppareil(appareil) {
    return [appareil?.marque?.nom, appareil?.nom].filter(Boolean).join(" ");
}

/** Total TTC des prestations choisies sur tous les appareils. */
export function totalPrestations(lignes = []) {
    return lignes.reduce((total, ligne) => total + (ligne.prestations || [])
        .reduce((t, p) => t + (parseFloat(String(p.prix).replace(",", ".")) || 0), 0), 0);
}

/** Nom proposé quand le technicien n'en tape pas : « Produit : prestations » pour chaque appareil (comme l'API). */
export function titreParDefaut(lignes = []) {
    const morceaux = lignes.map(ligne => {
        const prestas = (ligne.prestations || []).map(p => p.title).join(", ");
        return prestas ? `${nomAppareil(ligne.appareil)} : ${prestas}` : nomAppareil(ligne.appareil);
    });
    return [...new Set(morceaux)].join(" / ");
}

/** Corps envoyé à l'API pour enregistrer la prise en charge. */
export function donneesPourEnregistrer(client, lignes, descriptionTech, description, titre = "") {
    return {
        user_id: client?.id,
        title: (titre || "").trim() || null,
        description_tech: descriptionTech || null,
        description: description || null,
        appareils: lignes.map(ligne => ({
            product_id: ligne.appareil.id,
            user_appareil_id: ligne.userAppareilId || null,
            presta_ids: (ligne.prestations || []).map(p => p.id),
            accessoires: texteAccessoires(ligne.accessoires, ligne.accessoiresAutre),
            serial: ligne.serial || null,
            defauts: ligne.defauts || null,
            code: ligne.code || null,
        })),
    };
}
